import { render, staticRenderFns } from "./companySumTable.vue?vue&type=template&id=5d6bd7f6&scoped=true&"
import script from "./companySumTable.vue?vue&type=script&lang=js&"
export * from "./companySumTable.vue?vue&type=script&lang=js&"
import style0 from "./companySumTable.vue?vue&type=style&index=0&id=5d6bd7f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6bd7f6",
  null
  
)

export default component.exports